// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles___wrapper___3Dz9D","carousel-wrapper":"styles___carousel-wrapper___1BqMU","carousel-slide":"styles___carousel-slide___3bLh7"};